import React from 'react'

const MagnifyingGlassDollarsIcon = () => (
  <svg
    width="80"
    height="80"
    viewBox="0 0 80 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg">
    <g>
      <path
        d="M23.0091 33.2587C23.4191 33.2987 23.7991 33.3787 24.1491 33.4987C24.4991 33.6187 24.7991 33.7687 25.0291 33.9487L25.0791 33.9887L37.1191 30.2687C36.0391 30.2687 34.9791 30.1887 33.9391 30.0587C32.8991 29.9287 31.8991 29.7387 30.9591 29.4887C30.0191 29.2387 29.1291 28.9387 28.3391 28.5787C27.5391 28.2187 26.8291 27.8087 26.2191 27.3487C25.5691 26.8487 25.0791 26.3287 24.7591 25.7987C24.4391 25.2687 24.2691 24.7287 24.2591 24.1887C24.2491 23.6487 24.3791 23.1187 24.6591 22.6087C24.9391 22.0987 25.3491 21.5987 25.9091 21.1387L13.2991 24.8587C13.2991 24.8587 13.3591 24.8887 13.3891 24.9087C13.4191 24.9287 13.4491 24.9387 13.4791 24.9587C13.5091 24.9787 13.5391 24.9987 13.5691 25.0187C13.5991 25.0387 13.6191 25.0587 13.6491 25.0787C13.8691 25.2487 14.0091 25.4387 14.0591 25.6287C14.1191 25.8187 14.0891 26.0187 13.9891 26.2087C13.8891 26.3987 13.7091 26.5787 13.4691 26.7387C13.2191 26.8987 12.9091 27.0487 12.5291 27.1587C12.5191 27.1587 12.4991 27.1587 12.4891 27.1687C12.4791 27.1687 12.4591 27.1687 12.4491 27.1787C12.4391 27.1787 12.4191 27.1787 12.4091 27.1787C12.3991 27.1787 12.3791 27.1787 12.3691 27.1787L20.4091 33.5287C20.4091 33.5287 20.4391 33.5287 20.4491 33.5087C20.4591 33.5087 20.4791 33.5087 20.4891 33.4987C20.4991 33.4987 20.5191 33.4987 20.5291 33.4887C20.5391 33.4887 20.5591 33.4887 20.5691 33.4787C20.9491 33.3587 21.3691 33.2887 21.7891 33.2487C22.2091 33.2187 22.6291 33.2187 23.0391 33.2587H23.0091ZM20.8691 29.7987C20.5991 29.7687 20.3391 29.7187 20.1191 29.6387C19.8891 29.5587 19.6891 29.4587 19.5391 29.3387C19.3891 29.2187 19.2891 29.0887 19.2491 28.9587C19.2091 28.8287 19.2191 28.6887 19.2891 28.5587C19.3591 28.4287 19.4691 28.3087 19.6391 28.1987C19.7991 28.0887 20.0091 27.9887 20.2691 27.9187C20.5191 27.8387 20.7991 27.7887 21.0791 27.7687C21.3591 27.7487 21.6391 27.7487 21.8991 27.7687C22.1691 27.7987 22.4191 27.8487 22.6491 27.9287C22.8791 28.0087 23.0791 28.1087 23.2291 28.2187C23.3891 28.3387 23.4791 28.4687 23.5191 28.5987C23.5591 28.7287 23.5491 28.8687 23.4791 28.9987C23.4191 29.1287 23.2991 29.2487 23.1391 29.3587C22.9791 29.4687 22.7591 29.5687 22.5091 29.6487C22.2591 29.7287 21.9791 29.7787 21.6991 29.7987C21.4191 29.8187 21.1391 29.8187 20.8691 29.7987V29.7987Z"
        stroke="#009CDE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M52.6691 10.5293L3.11914 25.0093L20.0791 38.6593L48.3391 29.8293"
        stroke="#009CDE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M49.6901 15.0599C49.3601 14.9599 49.0601 14.8299 48.8301 14.6599C48.8001 14.6399 48.7801 14.6199 48.7501 14.5999C48.7301 14.5799 48.7001 14.5599 48.6801 14.5399C48.6601 14.5199 48.6401 14.4999 48.6201 14.4799C48.6001 14.4599 48.5801 14.4399 48.5601 14.4199L36.5801 17.9599C37.7001 17.9299 38.8101 17.9599 39.9001 18.0699C40.9901 18.1699 42.0501 18.3399 43.0601 18.5699C44.0701 18.7999 45.0301 19.0899 45.9001 19.4399C46.7701 19.7899 47.5601 20.2099 48.2401 20.6799"
        stroke="#009CDE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.11914 28.7891L19.8891 42.5091L49.9891 32.9291"
        stroke="#009CDE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.88086 32.3789L19.6509 46.0989L52.2209 35.7289"
        stroke="#009CDE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.71094 35.9395L19.4809 49.6595L55.1909 38.2895"
        stroke="#009CDE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.41016 39.8086L19.1802 53.5386L60.8702 40.2586"
        stroke="#009CDE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.4004 42.6496L70.0504 40.8496"
        stroke="#009CDE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2.17969 43.3984L18.9397 57.1284L61.4697 43.5784"
        stroke="#009CDE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.8203 45.6984L69.8803 44.3984"
        stroke="#009CDE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 46.959L18.77 60.679L59.94 47.569"
        stroke="#009CDE"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.7694 20.5391C34.8894 20.7191 33.9894 21.0291 33.2494 21.3891C31.2994 22.3391 30.1894 23.9891 32.1394 24.8191C34.1094 25.6691 36.1794 24.2691 37.9394 23.4691C38.9794 22.9891 40.0394 22.4791 41.3594 22.6191C42.8794 22.7691 43.4394 23.8491 42.9394 24.6991C42.6594 25.1891 42.0694 25.7091 41.4594 26.0991C40.3794 26.7891 38.4994 27.6791 37.0094 27.9191"
        stroke="#009CDE"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M31.1699 20.8594L42.9299 26.8494"
        stroke="#009CDE"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M78.4301 24.1402C78.4301 32.9202 71.5801 40.0402 63.1301 40.0402C54.6801 40.0402 47.8301 32.9202 47.8301 24.1402C47.8301 15.3602 54.6801 8.24023 63.1301 8.24023C71.5801 8.24023 78.4301 15.3602 78.4301 24.1402Z"
        stroke="#CCCCCC"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M75.27 24.1393C75.27 31.0993 69.84 36.7493 63.13 36.7493C56.43 36.7493 51 31.0993 51 24.1393C51 17.1693 56.43 11.5293 63.13 11.5293C69.83 11.5293 75.26 17.1793 75.27 24.1393Z"
        stroke="#CCCCCC"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M65.8192 69.6008V47.1008C65.8192 45.9708 64.6192 45.0608 63.1292 45.0508C61.6492 45.0508 60.4492 45.9708 60.4492 47.0908V69.5908C60.4492 70.3108 60.9392 70.9508 61.6892 71.3108C61.6892 71.3108 65.8192 72.3208 65.8192 69.5908V69.6008Z"
        stroke="#CCCCCC"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M64.1094 44.9798V40.0898"
        stroke="#CCCCCC"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
      <path
        d="M62.0898 45.2201L62.0998 43.3801L62.1198 40.0801"
        stroke="#CCCCCC"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
      />
    </g>
  </svg>
)

export default MagnifyingGlassDollarsIcon
